module.exports = __webpack_public_path__ + "img/public/SiteIcons/hostStepIcons/description.svg?00ba0159";